import { useEffect, useRef } from "react";
import { isMobile, scroll2Top } from "../utils/utils";
import ConfirmModificationBloc from "../blocs/post-signature/ConfirmModificationBloc";

export default function ConfirmModificationPage() {
  const pageGapRef = useRef<null | HTMLDivElement>(null);
  useEffect(() => {
    if (isMobile()) {
      pageGapRef.current?.scrollIntoView() 
    } else {
      scroll2Top();
    }
  }, []);

    return (
      <div className="entreprise-container">
        
        <h1 className="title ml-lg-desktop mb-sm">Page de confirmation</h1>
        <div ref={pageGapRef} className="page-gap" />
        <div className="page-content flex-grid bg-blanc shadow-noir p-lg m-lg-desktop">
            <ConfirmModificationBloc/>
        </div>
      </div>
    )

}